import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background"></div>
        <div className="hero-container">
          <div className="hero-content">
            <span className="hero-badge">Niels Höfner Digital Marketing</span>
            <h1 className="hero-title">
              Mache deine Marke<br />
              <span className="hero-highlight">sichtbar</span>
            </h1>
            <p className="hero-subtitle">
              Strategien, die Reichweite erzeugen.<br />
              Content, der Vertrauen aufbaut.<br />
              Ergebnisse, die dein Business verändern.
            </p>
            <div className="hero-actions">
              <Link to="/buchen" className="btn-primary">
                Termin buchen
                <span className="btn-arrow">→</span>
              </Link>
              <Link to="/services" className="btn-secondary">
                Meine Leistungen entdecken
              </Link>
            </div>
          </div>
          <div className="hero-visual">
            <img 
              src="https://customer-assets.emergentagent.com/job_content-excellence/artifacts/p0eslyp2_58822081-57E7-4138-8493-501B3263EAB3.png"
              alt="Niels Höfner"
              className="hero-image"
            />
          </div>
        </div>
      </section>

      {/* USP Section */}
      <section className="usp-section">
        <div className="section-container">
          <div className="section-header">
            <span className="section-label">Warum ich</span>
            <h2 className="section-title">Mehr als nur Social Media</h2>
            <p className="section-description">
              Strategisch. Praxisnah. Auf Augenhöhe.
            </p>
          </div>

          <div className="usp-grid">
            <div className="usp-card">
              <div className="usp-icon">🎯</div>
              <h3>Strategischer Weitblick</h3>
              <p>Maßgeschneiderte Strategien, die Reichweite, Sichtbarkeit und Wachstum nachhaltig steigern.</p>
            </div>
            <div className="usp-card">
              <div className="usp-icon">📈</div>
              <h3>Messbare Ergebnisse</h3>
              <p>Datengetriebenes Marketing für klare Ziele und messbare Erfolge, die dein Business nach vorne bringen.</p>
            </div>
            <div className="usp-card">
              <div className="usp-icon">👤</div>
              <h3>Persönliche Betreuung</h3>
              <p>Ich begleite dich individuell, transparent und auf Augenhöhe – von der Planung bis zur Umsetzung.</p>
            </div>
            <div className="usp-card">
              <div className="usp-icon">💡</div>
              <h3>Expertise & Erfahrung</h3>
              <p>Fundiertes Wissen im Bereich Management und Digital Marketing kombiniert mit praxisnaher Erfahrung.</p>
            </div>
            <div className="usp-card">
              <div className="usp-icon">🏆</div>
              <h3>Mini-MBA Qualifikation</h3>
              <p>Zertifiziert vom International Business Management Institute Berlin – Expertise auf höchstem Niveau.</p>
            </div>
            <div className="usp-card">
              <div className="usp-icon">✨</div>
              <h3>Höchste Qualität</h3>
              <p>Mein Anspruch an Ästhetik, Detail und Wirkung – damit deine Marke wirklich heraussticht.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="services-preview">
        <div className="section-container">
          <div className="section-header">
            <span className="section-label">Meine Leistungen</span>
            <h2 className="section-title">Was ich für dich tue</h2>
          </div>

          <div className="services-grid-preview">
            <div className="service-preview-card">
              <h3>Social Media Management</h3>
              <p>Strategisches Management deiner Kanäle für nachhaltige Sichtbarkeit und echte Community.</p>
            </div>
            <div className="service-preview-card">
              <h3>Content Creation</h3>
              <p>Hochwertige Inhalte – von Reels über Carousels bis zu Stories. Visuell stark. Strategisch durchdacht.</p>
            </div>
            <div className="service-preview-card">
              <h3>Paid Advertising</h3>
              <p>Performance-Ads auf Meta, TikTok & Co. – Reichweite, Leads und Sales planbar generieren.</p>
            </div>
            <div className="service-preview-card">
              <h3>Strategy & Consulting</h3>
              <p>Klare Marketing-Strategie, Positionierung und Branding – das Fundament für nachhaltiges Wachstum.</p>
            </div>
          </div>

          <div className="section-cta">
            <Link to="/services" className="btn-secondary">
              Alle Leistungen ansehen →
            </Link>
          </div>
        </div>
      </section>

      {/* What to Expect Section */}
      <section className="expect-section">
        <div className="section-container">
          <div className="section-header">
            <span className="section-label">Was dich erwartet</span>
            <h2 className="section-title">Konkrete Ergebnisse für dein Business</h2>
            <p className="section-description">
              Das sind die messbaren Resultate, die meine Kunden durch professionelles Social Media Marketing erreichen.
            </p>
          </div>

          <div className="expect-grid">
            <div className="expect-card">
              <div className="expect-number">+250%</div>
              <h3>Mehr Reichweite</h3>
              <p>Durchschnittliches Wachstum der organischen Reichweite innerhalb der ersten 90 Tage durch strategische Content-Optimierung.</p>
            </div>
            <div className="expect-card">
              <div className="expect-number">+180%</div>
              <h3>Engagement-Rate</h3>
              <p>Steigerung der Interaktionen durch zielgruppengerechten Content und durchdachte Community-Strategie.</p>
            </div>
            <div className="expect-card">
              <div className="expect-number">3-5x</div>
              <h3>Qualifizierte Anfragen</h3>
              <p>Mehr Kundenanfragen durch optimierte Funnel-Strategie und gezielte Lead-Generierung über Social Media.</p>
            </div>
            <div className="expect-card">
              <div className="expect-number">100%</div>
              <h3>Transparente Reports</h3>
              <p>Monatliche Auswertungen mit klaren KPIs, damit du jederzeit weißt, wie sich dein Investment auszahlt.</p>
            </div>
          </div>

          <div className="expect-disclaimer">
            <p>* Werte basieren auf Erfahrungswerten der Branche und durchschnittlichen Resultaten bei strategischer Umsetzung. Individuelle Ergebnisse können variieren und hängen von Branche, Startposition und Zusammenarbeit ab.</p>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <div className="section-container">
          <div className="section-header">
            <span className="section-label">Mein Vorgehen</span>
            <h2 className="section-title">Von der Idee zur Wirkung</h2>
          </div>

          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">01</div>
              <h3>Analyse & Strategie</h3>
              <p>Ich verstehe dein Business, deine Zielgruppe und deine Ziele. Daraus entsteht eine maßgeschneiderte Strategie.</p>
            </div>
            <div className="process-step">
              <div className="step-number">02</div>
              <h3>Content & Umsetzung</h3>
              <p>Hochwertiger Content, der zur Marke passt und gezielt auf die definierten Ziele einzahlt.</p>
            </div>
            <div className="process-step">
              <div className="step-number">03</div>
              <h3>Analyse & Optimierung</h3>
              <p>Kontinuierliches Monitoring, Auswertung der Performance und datenbasierte Optimierung für maximale Wirkung.</p>
            </div>
            <div className="process-step">
              <div className="step-number">04</div>
              <h3>Skalierung & Wachstum</h3>
              <p>Skalierung der erfolgreichen Maßnahmen und Aufbau eines nachhaltigen Wachstumssystems.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="home-cta-section">
        <div className="section-container">
          <div className="cta-content">
            <h2>Bereit, deine Marke sichtbar zu machen?</h2>
            <p>Lass uns gemeinsam herausfinden, wie Social Media dein Business nach vorne bringen kann. Im kostenlosen Erstgespräch besprechen wir deine Ziele und Möglichkeiten.</p>
            <div className="cta-buttons-group">
              <Link to="/buchen" className="btn-primary">
                Direkt Termin buchen
                <span className="btn-arrow">→</span>
              </Link>
              <Link to="/kontakt" className="btn-secondary">
                Kontaktformular
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
